import { DestroyRef, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Subject } from 'rxjs';
import { ReservationSummaryStoreService } from '../reservation-summary/services/reservation-summary-store.service';
import { ComfortPackageMode, comfortPackageDataFactory } from './comfort-package-data.factory';
import { ComfortPackageComponent, ComfortPackageDialogData } from '@oskar-frontend/comfort-package';

export class ComfortPackageLogic {
	dataChanged$ = new Subject<ComfortPackageDialogData>();

	store = inject(ReservationSummaryStoreService);
	destroyRef = inject(DestroyRef);

	protected listenToTheReservationChanges(mode: ComfortPackageMode): void {
		this.store
			.getters()
			.reservation()
			.pipe(takeUntilDestroyed(this.destroyRef))
			.subscribe((reservation) => {
				this.dataChanged$.next(comfortPackageDataFactory(reservation, mode));
			});
	}
}

export function refetchNewLayout(
	comfortPackageComponentInstance: ComfortPackageComponent,
	data: ComfortPackageDialogData,
): void {
	comfortPackageComponentInstance.data.set(data);
	comfortPackageComponentInstance.comfortPackageService.buses.set([]);
	comfortPackageComponentInstance.setChosenSeatsAfterLayoutFetched();
	comfortPackageComponentInstance.fetch();
}
